// import { useSignoutOnInactivityEffect } from 'util/auth/use-signout-on-inactivity';

export default function InactivitySignoutWatcher({ children }) {
  // Inactivity signout effect is temporarily disabled <https://firstconnect.atlassian.net/browse/FRC-8670>
  // useSignoutOnInactivityEffect();

  return children;
}
